// extracted by css-extract-rspack-plugin
export default {"warningContainer":"NotificationScheduleWarning-module__warningContainer___oowAN","warningText":"NotificationScheduleWarning-module__warningText___xJMBP"};